import React, { Component } from 'react';
import InwardingApiHandler from './../../InwardingApiHandler.js';
import ExpDropSelector from './../../../../commons/ExpDropSelector.js';
import FileUploader from './../../../../commons/FileUploader.js';
import PDFViewer from './../../../../commons/PDFViewer.js';
import ImageViewer from './../../../../commons/ImageViewer';
import doc_done from './../../../../assets/img/doc_done.png';
import close from './../../../../assets/img/close.png';
import Dialog from '@material-ui/core/Dialog';
import ErrorBox from './../../../../commons/ErrorBox';
import InputFloating from './../../../../commons/InputFloating.js';
import CONF from '../../../../config/config.js';

const numfor = new Intl.NumberFormat('en-IN', {
	style: 'currency',
	currency: 'INR',
	minimumFractionDigits: 0
});

var invoiceTypes = ["Tax Invoice", "Bill Of Supply", "Duplicate Invoice", "Credit Bill", "Delivery Slip", "Lorry Receipt", "Extra Copy", "Order Form", "Return Challan", "Others"];

export default class InvoiceInward extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pods: [],
			enableNewPo: true,
			podNumber: '',
			selectedInvoiceType: 'Tax Invoice',
			uploadResponse: null,
			invoiceType: null,
			vendorInvoiceNo: '',
			invoiceDate: '',
			invoiceAmount: '',
			noOfUniqueItems: '',
			docCreated: false,
			docCreatedBox: false,
			createdInvoiceId: null,
			fileType: ''
		}
	}

	getPODDetails = () => {
		const { podNumber } = this.state;
		let pod = podNumber.toUpperCase();
		InwardingApiHandler.getPODDetails(pod)
			.then((resp) => {
				this.setState({ enableNewPo: false });
				this.setState(prevState => ({
					pods: [...prevState.pods, resp]
				}))
			}).catch((error) => {
				this.setState({ error: error.error.error });
			}).finally(() => {

			})
	}

	createInwardingDocument = () => {
		const { pods, selectedInvoiceType, uploadResponse, vendorInvoiceNo, invoiceDate, invoiceAmount, noOfUniqueItems } = this.state;
		var request = {
			invoiceDate: new Date(invoiceDate).getTime(),
			rpoOrderIds: pods.map(p => {
				return p.orderId
			}),
			vendorId: pods.map(p => {
				return p.vendorId
			})[0],
			vendorInvoiceNumber: vendorInvoiceNo,
			documentId: uploadResponse,
			numberOfItems: noOfUniqueItems,
			invoiceAmount: invoiceAmount,
			invoiceType: selectedInvoiceType
		};
		this.setState({ loading: true })
		InwardingApiHandler.createInwardingDocument(request)
			.then((resp) => {
				this.setState({ docCreated: true, docCreatedBox: true, createdInvoiceId: resp })
			}).catch((error) => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ loading: false })
			})
	}


	podNumberChanged = (e) => {
		this.setState({ podNumber: e.target.value });
	}

	wantToAddNewPO = () => {
		this.setState({ enableNewPo: true, podNumber: '' });
	}

	handleUploadResponse = (resp, type) => {
		this.setState({ uploadResponse: resp, fileType: type });
	}

	invoiceDetailChanged = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}

	invoiceTypeSelected = (type) => {
		this.setState({ selectedInvoiceType: type });
	}

	onDeleteClick = () => {
		this.setState({ uploadResponse: null });
	}

	canDocumentCreationHappen = () => {
		const { pods, selectedInvoiceType, uploadResponse, vendorInvoiceNo, invoiceDate, invoiceAmount, noOfUniqueItems } = this.state;
		if (pods.length > 0 && selectedInvoiceType && uploadResponse && vendorInvoiceNo && invoiceDate && invoiceAmount && noOfUniqueItems && !this.invoiceDateValidation()) {
			return true;
		}
		return false;
	}

	removePOD = (index) => {
		var i = this.state.pods;
		i.splice(index, 1);
		if (i.length === 0) {
			this.setState({ enableNewPo: true });
		}
		this.setState({ pods: i, podNumber: '' });
	}

	closeDocCreatedBox = () => {
		this.setState({ docCreatedBox: false });
	}

	goBackPage = () => {
		this.props.history.push({
			pathname: '/Inwarding'
		})
	}

	startInwarding = () => {
		const { createdInvoiceId } = this.state;
		this.props.history.push({
			pathname: '/Inwarding/AddPallet/' + createdInvoiceId
		})
	}

	invoiceDateValidation() {
		if (this.state.invoiceDate) {
			var currentDate = new Date();
			var choosedDate = new Date(this.state.invoiceDate);

			var timeDiff = Math.abs(currentDate.getTime() - choosedDate.getTime());
			var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
			if (diffDays > 7) {
				return true;
			}
		}
		return false;
	}

	closeError = () => { this.setState({ error: null }) }


	showScannedPods = () => {
		const { pods, docCreated } = this.state;
		return (
			pods.map((p, index) => {
				return (
					<div className="top-twenty" key={index}>
						<div className="row">
							<div className="col-xs-8">POD # {index + 1}</div>
							<div className="col-xs-4 text-right">
								{(!docCreated) ?
									<div onClick={() => { this.removePOD(index) }}><img src={close} style={{ width: '22px', height: '22px', opacity: '0.7' }} alt="x" /></div> : null
								}
							</div>
						</div>
						<div className="top-ten">
							<div className="c-b-u">Facility Centre</div>
							<div className="pod-itm-big">{p.facilityName}</div>
						</div>
						<div>
							<div className="c-b-u">Vendor Name</div>
							<div className="pod-itm-big">{p.vendorName}</div>
						</div>
						<div className="top-ten">
							<div className="c-b-u">Seller Name</div>
							<div className="pod-itm-big">{p.sellerName}</div>
						</div>
					</div>
				)
			})
		)
	}

	showNewPOD = () => {
		const { pods, enableNewPo, podNumber, docCreated } = this.state;
		return (
			<div>
				{(!docCreated) ?
					<div>
						{(enableNewPo) ?
							<div className="top-twenty">
								<div>POD # {pods.length + 1}</div>
								<div className="top-twenty">
									<div className="row">
										<div className="col-xs-10 no-right-padding">
											<InputFloating type="text" label="Enter POD Number" value={podNumber} onChange={this.podNumberChanged} />
										</div>
										<div className="col-xs-2 no-left-padding">
											<button className={"btn pod-btn " + (podNumber ? "pod-in" : "pod-dis")} disabled={(podNumber ? false : true)} onClick={this.getPODDetails}><i className="fas fa-arrow-right"></i></button>
										</div>
									</div>
								</div>
							</div>
							:
							<div className="c-b-u text-right">
								<div style={{ textDecoration: 'underline' }} onClick={this.wantToAddNewPO}>+Add Another POD</div>
							</div>
						}
					</div> : null
				}
			</div>)
	}

	showEnterInvoiceDetails = () => {
		const { selectedInvoiceType, vendorInvoiceNo, invoiceDate, noOfUniqueItems, invoiceAmount, uploadResponse, docCreated, fileType } = this.state;
		return (
			<div>
				<div className="v-imp-txt">Invoice Details</div>
				<div className="top-twenty">
					{(docCreated) ?
						<div>
							<div className="c-b-u">Document Type</div>
							<div className="pod-itm-big">{selectedInvoiceType}</div>
						</div>
						:
						<ExpDropSelector options={invoiceTypes} selected={selectedInvoiceType} classes={{ drop: 'invoice-type-drop' }} selctionChange={this.invoiceTypeSelected} type={'Invoice Type'} />
					}
				</div>
				<div className="top-twenty">
					<div className="c-b-u">Upload Invoice</div>
					<div className="top-twenty">
						{(uploadResponse) ?
							<div>
								{(fileType === "application/pdf") ?
									<div>
										{(docCreated) ?
											<PDFViewer url={uploadResponse} />
											:
											<PDFViewer url={uploadResponse} onDeleteClick={this.onDeleteClick} />
										}
									</div>
									:
									<div>
										{(docCreated) ?
											<ImageViewer src={uploadResponse} alt='Img' />
											:
											<ImageViewer src={uploadResponse} shouldRemove={true} onRemove={this.onDeleteClick} alt='Img' />
										}
									</div>

								}
							</div>
							:
							<div>
								<FileUploader 
									url="inwarding/upload" 
									noMessage="true" 
									handleUploadResponse={this.handleUploadResponse} 
									accept='.pdf' 
									fileSizeLimit={CONF.FILE_SIZE_LIMIT_FOR_PDF_IN_BYTES}
								/>
							</div>
						}
					</div>
				</div>
				<div className="top-twenty">
					{(docCreated) ?
						<div>
							<div className="c-b-u">Vendor Invoice Number</div>
							<div className="pod-itm-big">{vendorInvoiceNo}</div>
						</div>
						:
						<InputFloating type="text" label="Vendor Invoice Number" name="vendorInvoiceNo" value={vendorInvoiceNo} onChange={this.invoiceDetailChanged} />
					}
				</div>
				<div className="top-twenty">
					{(docCreated) ?
						<div>
							<div className="c-b-u">Vendor Invoice Date</div>
							<div className="pod-itm-big">{invoiceDate}</div>
						</div>
						:
						<div>
							<InputFloating type="date" label="Vendor Invoice Date" name="invoiceDate" value={invoiceDate} onChange={this.invoiceDetailChanged} />
							{(this.invoiceDateValidation()) ?
								<div className="error-text top-ten">Invoice Date can not be more than 7 Days older from today.</div> : null
							}
						</div>
					}

				</div>
				<div className="top-twenty">
					{(docCreated) ?
						<div>
							<div className="c-b-u">No. of Unique Items</div>
							<div className="pod-itm-big">{noOfUniqueItems}</div>
						</div>
						:
						<InputFloating type="text" label="No. of Unique Items" name="noOfUniqueItems" value={noOfUniqueItems} onChange={this.invoiceDetailChanged} />
					}
				</div>
				<div className="top-twenty">
					{(docCreated) ?
						<div>
							<div className="c-b-u">Invoice Amount</div>
							<div className="pod-itm-big">{numfor.format(invoiceAmount)}</div>
						</div>
						:
						<div className="input-group">
							<span className="input-group-addon">₹</span>
							<InputFloating type="number" label="Invoice Amount" name="invoiceAmount" value={invoiceAmount} onChange={this.invoiceDetailChanged} />
						</div>
					}
				</div>
			</div>
		)
	}

	render() {
		const { docCreatedBox, docCreated } = this.state;
		return (
			<div>
				<div style={{ padding: '10px', marginBottom: '80px' }}>
					<div className="invoice-inward-wrapper">
						<div className="v-imp-txt">Purchase Order Document (POD) Details</div>
						<div>{this.showScannedPods()}</div>
						<div>{this.showNewPOD()}</div>
						<div className="pod-seperator"></div>
						<div>{this.showEnterInvoiceDetails()}</div>
					</div>
				</div>
				<div className="btm-actn-br">
					{(docCreated) ?
						<div className="row">
							<div className="col-xs-6"><button className="btn btn-big-norm" onClick={this.goBackPage}>Back</button></div>
							<div className="col-xs-6"><button className="btn btn-big-green" onClick={this.startInwarding}>Proceed To Inward</button></div>
						</div>
						:
						<div className="row">
							<div className="col-xs-2"></div>
							<div className="col-xs-8"><button className={"btn " + (this.canDocumentCreationHappen() ? "btn-big-blue" : "btn-big-norm")} disabled={this.canDocumentCreationHappen() ? false : true} onClick={this.createInwardingDocument}>Create Inwarding Document</button></div>
							<div className="col-xs-2"></div>
						</div>
					}
				</div>
				<Dialog open={docCreatedBox} maxWidth="lg" fullWidth={true} onClose={this.closeDocCreatedBox}>
					<div style={{ fontSize: '18px', textAlign: 'center', padding: '10px' }}>
						<div className="text-right" onClick={this.closeDocCreatedBox}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
						<div className="top-twenty"><img src={doc_done} alt="success-img" style={{ height: '125px' }} /></div>
						<div className="top-thirty">Document Created Successfully</div>
						<div className="top-thirty"></div>
					</div>
				</Dialog>
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/InvoiceInward.js